export default __webpack_public_path__ + "static/media/V2-CARROUSEL_4.c726467a.jpg";